import React, { useCallback, useState } from 'react'
import { AUTH_STEPS } from 'constants/auth'
import { USER_DATA_KEYS } from 'constants/user-data'
import { useBreakpoints } from 'hooks'

import AuthModal from 'components/AuthModal'
import Button from 'components/Button'
import userProfileBg from './images/user-profile-bg.png'
import userPreferencesBg from './images/user-preferences-bg.png'
import userDataBg from './images/user-data-bg.jpg'

const content = {
  [USER_DATA_KEYS.PROFILE]: {
    intro: 'TELL US ABOUT YOU',
    bgImage: userProfileBg,
  },
  [USER_DATA_KEYS.PREFERENCES]: {
    intro: 'WHAT ARE YOU LOOKING FOR?',
    bgImage: userPreferencesBg,
  },
}

const UserData = ({ incompleteApplicationData, onComplete }) => {
  const [dataKey, setDataKey] = useState(incompleteApplicationData?.key)
  const { md } = useBreakpoints()
  const [showDataModal, setShowDataModal] = useState(false)

  const handleComplete = useCallback(() => {
    setDataKey(key => incompleteApplicationData?.key || key)
    onComplete()
  }, [incompleteApplicationData?.key, onComplete])

  if (!dataKey) {
    return null
  }

  return (
    <div className="w-full flex flex-col items-center font-ownersWide text-center">
      {incompleteApplicationData && (
        <>
          <div className="text-xl mb-1 uppercase font-medium">
            your database entry is almost complete
          </div>
          <div className="text-base opacity-50 mb-4">
            Tell us a bit about you, and join the largest network of eligible singles in the nation
          </div>
          <div
            className="flex flex-col items-center border border-solid border-white border-opacity-10 w-full rounded-lg py-5 px-3 mb-5 bg-cover bg-center bg-no-repeat h-96 md:h-108 md:mb-6"
            style={{
              backgroundImage: `url(${content[incompleteApplicationData.key].bgImage})`,
            }}
          >
            <div className="border border-solid opacity-50 rounded-full text-xs px-3 py-1.5 mb-3">
              MATCHMAKING FOUNDATIONS
            </div>
            <div
              className="text-xl tracking-widest"
              style={{
                maxWidth: md ? '80%' : '250px',
              }}
            >
              {content[incompleteApplicationData.key].intro}
            </div>
          </div>
          <Button
            className="bg-white w-full rounded-3xl py-5 mb-4"
            onClick={() => setShowDataModal(true)}
          >
            <span className="text-black font-medium">START</span>
          </Button>
          <div className="text-base">
            {incompleteApplicationData.completedFields}/{incompleteApplicationData.totalFields}{' '}
            answered
          </div>
        </>
      )}
      {showDataModal && (
        <div
          className="fixed left-0 top-0 z-100 bg-center bg-cover"
          style={{
            width: '100vw',
            height: '100vh',
            backdropFilter: 'blur(10px)',
            backgroundImage: `url(${userDataBg})`,
          }}
        >
          <div className="bg-black bg-opacity-70 w-full h-full" />
        </div>
      )}
      <AuthModal
        key={dataKey}
        show={showDataModal}
        authStep={AUTH_STEPS.USER_DATA}
        data={{
          dataKey,
        }}
        onClose={() => {
          setShowDataModal(false)
          handleComplete() // Run completeness check on close
        }}
        onComplete={handleComplete}
      />
    </div>
  )
}

export default UserData
